import router from '@/router/router';
import store from '@/store/Store';
import { AxiosInstance } from 'axios';

export async function redirectToLoginPage() {
  const spaLoginPage = '/login';
  const spaLoginErrorPage = '/unauthorized';
  if (router.currentRoute.path !== spaLoginPage) {
    await store.dispatch('userModule/logout');
    if (window.self !== window.top) await router.push(spaLoginErrorPage);
    else await router.push(spaLoginPage);
  }
  return spaLoginPage;
}

export function setUpRedirectToLogin($http: AxiosInstance) {
  $http.interceptors.response.use(
    response => {
      if (response.status === 401 && !response.request.responseURL.includes('/auth')) {
        redirectToLoginPage().then(() => {
          return Promise.reject('Unauthorized');
        });
      }
      return response;
    },
    error => {
      if (
        error.response?.status &&
        [401, 403].includes(error.response?.status) &&
        !error.response?.request.responseURL.includes('/auth')
      ) {
        redirectToLoginPage()
          .then(() => {
            return Promise.reject(error.response?.data || error.message);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      } else {
        return Promise.reject(error.response?.data || error.message);
      }
    },
  );
}
